import React from 'react'

import MainPage from '../Components/MainPage/MainPage'
import AboutUs from '../Components/AboutUs/AboutUs'
import Responsibilities from '../Components/Responsibilities/Responsibilities'
// import Photos from '../Components/Photos/Photos'
import Contact from '../Components/Contact/Contact'
import Gallery from '../Components/Gallery/Gallery'

class App extends React.Component {
  render() {
    const itemsInNavbar = [
      { title: 'o nas', name: 'about' },
      { title: 'oferta', name: 'offer' },
      // { title: "kadra", name: "cadre" },
      { title: 'galeria', name: 'gallery' },
      { title: 'kontakt', name: 'contact' }
    ]

    const responsibilities = [
      {
        text: `CZYSZCZENIE PRZEWODÓW KOMINOWYCH DYMOWYCH, SPALINOWYCH i WENTYLACYJNYCH`,
        icon: 'broom'
      },
      {
        text: `ODBIORY PRZEWODÓW KOMINOWYCH W BUDYNKACH MIESZKALNYCH I PRZEMYSŁOWYCH`,
        icon: 'industry'
      },
      {
        text: `EKSPERTYZY STANU TECHNICZNEGO PRZEWODÓW KOMINOWYCH`,
        icon: 'file-signature'
      },
      {
        text: `PRZEPROWADZANIE INWENTARYZACJI ISTNIEJĄCYCH URZĄDZEŃ KOMINOWYCH`,
        icon: 'ownChimney'
      },
      { text: `OPINIOWANIE PRAWIDŁOWOŚCI PODŁĄCZEŃ KOMINOWYCH`, icon: 'link' },
      {
        text: `PEŁNE DORADZTWO Z ZAKRESU PRZEWODÓW KOMINOWYCH`,
        icon: 'handshake'
      },
      { text: `PRZEPROWADZANIE  POMIARÓW CIĄGÓW KOMINOWYCH`, icon: 'ruler' },
      {
        text: `WYKONYWANIE ANALIZY SPALIN W URZĄDZENIACH GAZOWYCH`,
        icon: 'ownAnalytics'
      },
      {
        text: `OPINIOWANIE PRZEWODÓW KOMINOWYCH DLA POTRZEB ROZDZIELNI GAZU I PROGRAMÓW OGRANICZANIA NISKIEJ EMISJI`,
        icon: 'ownEnvironment'
      },
      {
        text: `SPRAWDZANIE PRZEWODÓW I KANAŁÓW KOMINOWYCH PRZY UŻYCIU KAMERY  KOMINOWEJ`,
        icon: 'camera-retro'
      },
      { text: `UDRAŻNIANIE PRZEWODÓW KOMINOWYCH`, icon: 'ownRope' },
      {
        text: `MECHANICZNE CZYSZCZENIE PRZEWODÓW KOMINOWYCH PRZY UŻYCIU FREZARKI KOMINOWEJ`,
        icon: 'ownMechanical'
      },
      {
        text: `OBSŁUGA WENTYLACJI MECHANICZNEJ : POMIARY I KONTROLE`,
        icon: 'ownVentilation'
      },
      { text: `MONTAŻ NASAD KOMINOWYCH`, icon: 'ownInstallation' },
      {
        text: `PRZEPROWADZANIE OKRESOWYCH , OBOWIĄZKOWYCH KONTROLI STANU
    TECHNICZNEGO PRZEWODÓW KOMINOWYCH ZGODNIE Z OBOWIĄZUJĄCYMI
    PRZEPISAMI W TYM ZAKRESI`,
        icon: 'undo'
      }
    ]

    return (
      <>
        <MainPage itemsInNavbar={itemsInNavbar} />
        <AboutUs />
        <Responsibilities responsibilities={responsibilities} />
        {/* <Photos /> */}
        <Gallery />
        <Contact />
      </>
    )
  }
}

export default App
